import { Star, MapPin, DollarSign, Plus, Heart } from "lucide-react";
import { useI18n, useL } from "../i18n";
import { useTrip } from "../TripContext";
import { useFavorites } from "../FavoritesContext";
import { Link } from "react-router-dom";

export default function DestinationCard({ dest }) {
  const { lang, t } = useI18n();
  const L = useL();
  const { addStop } = useTrip();
  const { isFavorite, toggle } = useFavorites();
  const fav = isFavorite(dest.id);
  const isAr = lang === "ar";
  const title = isAr ? dest.name_ar : dest.name_en;
  const city = isAr ? dest.city_ar : dest.city_en;

  return (
    <article
      className="hoverable-card group relative bg-white rounded-3xl overflow-hidden border border-[#E6DED3] flex flex-col"
      data-testid={`destination-card-${dest.id}`}
    >
      <Link to={`/destination/${dest.id}`} className="block relative aspect-[4/3] overflow-hidden bg-[#1C1917]">
        <img
          src={dest.image_url}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute top-3 end-3 rounded-full bg-white/95 backdrop-blur px-2.5 py-1 flex items-center gap-1 text-xs font-medium">
          <Star className="h-3 w-3 fill-[#D97706] text-[#D97706]" />
          {dest.rating}
        </div>
        <button
          onClick={(e) => { e.preventDefault(); toggle(dest); }}
          data-testid={`favorite-toggle-${dest.id}`}
          aria-label="favorite"
          className={`absolute top-3 start-3 h-9 w-9 grid place-items-center rounded-full backdrop-blur transition-all ${
            fav ? "bg-[#C85A32] text-white" : "bg-white/90 text-[#1C1917] hover:bg-white"
          }`}
        >
          <Heart className={`h-4 w-4 ${fav ? "fill-white" : ""}`} />
        </button>
        <div className="absolute bottom-3 start-3 rounded-full bg-[#1C1917]/85 text-[#FAF7F2] px-2.5 py-1 flex items-center gap-1.5 text-[11px] uppercase tracking-wider backdrop-blur">
          <MapPin className="h-3 w-3" />
          {city}
        </div>
      </Link>

      <div className="p-5 flex flex-col flex-1">
        <div className="text-[11px] uppercase tracking-widest text-[#C85A32] font-semibold">
          {isAr ? dest.category_ar : (dest.category || "").replace(/_/g, " ")}
        </div>
        <h3 className="mt-2 font-display text-xl text-[#1C1917] leading-tight">{title}</h3>
        <p className="mt-2 text-sm text-[#57534E] line-clamp-2">
          {isAr ? dest.description_ar : dest.description_en}
        </p>

        <div className="mt-4 flex items-end justify-between pt-4 border-t border-[#E6DED3]">
          <div>
            <div className="text-[10px] uppercase tracking-widest text-[#78716C]">{t("monthly_avg")}</div>
            <div className="font-display text-xl text-[#1C1917] flex items-center gap-1">
              <DollarSign className="h-4 w-4 text-[#C85A32]" />
              {dest.avg_daily_cost_usd}
              <span className="text-xs text-[#78716C] font-normal ms-1">/ {t("per_day")}</span>
            </div>
          </div>
          <button
            onClick={() => addStop(dest)}
            data-testid={`add-to-trip-${dest.id}`}
            className="h-10 w-10 rounded-full bg-[#1C1917] hover:bg-[#C85A32] text-[#FAF7F2] grid place-items-center transition-colors"
            title={t("add_to_trip")}
          >
            <Plus className="h-4 w-4" />
          </button>
        </div>
      </div>
    </article>
  );
}
